import React, { useEffect } from 'react';
import {
    Box,
    CircularProgress,
    // ListItem,
    // Card,
    // CardContent,
} from '@mui/material';
import Helper from '../../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
import Title from '../../../sharedcomponents/title/title'; 
import UserMediaCircuitList from './userMediaCircuitList';
import CustomizedSnackbars from '../../../sharedcomponents/snackbar/snackBar';
import UserListDialog from './userListDialog';
import { Downgraded, useState } from '@hookstate/core';
 
const AssignActivityList = (props) => {
    // const classes = useStyles();
    const eventInfo = Helper.getStorage('eventInfo');
    const [userModulePermissions, setUserModulePermissions] = React.useState({
        columns: null,
        rows: null,
    });
    const [loading, setLoading] = React.useState(false);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const allParticipants = useState([]);
    const inParticiapnt = useState();
    const mediaCircuitActivity = useState();
    const openDialog = useState(false);
    // const users = useState([]);
    const userDialog = useState([])
    useEffect(() => {
        getAllData();
        getParticipants();
    }, []);

    async function getAllData() {
        const modulesInfo = ApiHelper.get(APIURLConstants.GET_MEDIA_CIRCUIT(eventInfo.eventID));
        const userModulesInfo = ApiHelper.get(
            APIURLConstants.GET_EVENT_USER_MEDIA_CIRCUIT(eventInfo.eventID)
        );
        let newUserModulePermissions = {
            columns: [],
            rows: [],
        };
        setLoading(false);
        await Promise.all([modulesInfo, userModulesInfo]).then((result) => {
            const modules = result[0].data;
            const users = result[1].data;
            inParticiapnt.set(users)
            mediaCircuitActivity.set(modules);
            if (modules.length > 0 && users.length > 0) {
                newUserModulePermissions.columns.push({
                    id: 'userName',
                    label: 'User',
                    mediaCircuitID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                    completedCount:0,  
                    inCompletedCount:0,  
                });
                newUserModulePermissions.columns.push({
                    id: 'role',
                    label: 'Role',
                    mediaCircuitID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'left',
                    completedCount:0,  
                    inCompletedCount:0, 
                });
                newUserModulePermissions.columns.push({
                    id: 'tags',
                    label: 'Tags',
                    mediaCircuitID: 0,
                    showPermission: false,
                    permission: null,
                    align: 'center',
                    completedCount:0,  
                    inCompletedCount:0, 
                });
                newUserModulePermissions.columns.push({
                    id: 'allModules',
                    label: 'All Media Circuit',
                    mediaCircuitID: 0,
                    showPermission: true,
                    permission: null,
                    align: 'center',
                    completedCount:0,  
                    inCompletedCount:0, 
                });

                modules.map((item) => {
                    newUserModulePermissions.columns.push({
                        id: item.name.toLowerCase(),
                        label: item.name + '(' + item.location + ')',
                        mediaCircuitID: item.mediaCircuitID,
                        showPermission: true,
                        permission: null,
                        showLabel: false,
                        align: 'center',
                        completedCount:0,  
                        inCompletedCount:0,                         
                    });
                });

                let usersData = [];
                users.map((user) => {
                    let rowObj = {
                        userName: {
                            label: user.userName,
                            userID: user.userID,
                            mediaCircuitID: 0,
                            showPermission: false,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            align: 'left',
                        },
                        role: {
                            label: user.role,
                            mediaCircuitID: 0,
                            showPermission: false,
                            showLabel: true,
                            showChips: false,
                            permission: null,
                            align: 'left',
                        },
                        tags: {
                            label: user.userTags,
                            mediaCircuitID: 0,
                            showPermission: false,
                            showLabel: false,
                            showChips: true,
                            permission: null,
                            align: 'center',
                        },
                        allModules: {
                            label: 'All Modules',
                            mediaCircuitID: 0,
                            showPermission: true,
                            showLabel: false,
                            showChips: false,
                            permission: null,
                            align: 'center',
                        },
                    };
                    if (modules) {
                        if (
                            modules.length > 0 &&
                            user.userMediaCircuitAccessTo.length > 0 &&
                            user.userMediaCircuitAccessTo.length ==
                            modules.length
                        ) {
                            let check = {};
                            user.userMediaCircuitAccessTo.forEach((perm) => {
                                check[perm.permission]
                                    ? check[perm.permission]++
                                    : 0;
                            });
                        }
                        modules.map((module) => {
                            if (
                                user.userMediaCircuitAccessTo &&
                                user.userMediaCircuitAccessTo.length > 0
                            ) {
                                let fIndex =
                                    user.userMediaCircuitAccessTo.findIndex(
                                        (row) => {
                                            return (
                                                row.mediaCircuitID ==
                                                module.mediaCircuitID
                                            );
                                        }
                                    );
                                if (fIndex > -1) {
                                    rowObj[module.name.toLowerCase()] = {
                                        label: module.name,
                                        mediaCircuitID: module.mediaCircuitID,
                                        showPermission: true,
                                        permission:
                                            user.userMediaCircuitAccessTo[
                                                fIndex
                                            ].status,
                                        showLabel: false,
                                        showChips: false,
                                        align: 'center',
                                    };
                                } else {
                                    rowObj[module.name.toLowerCase()] = {
                                        label: module.name,
                                        mediaCircuitID: module.mediaCircuitID,
                                        showPermission: true,
                                        permission: null,
                                        showLabel: false,
                                        showChips: false,
                                        align: 'center',
                                    };
                                }
                            } else {
                                rowObj[module.name.toLowerCase()] = {
                                    label: module.name,
                                    mediaCircuitID: module.mediaCircuitID,
                                    showPermission: true,
                                    permission: null,
                                    showLabel: false,
                                    showChips: false,
                                    align: 'center',
                                };
                            }
                        });
                    }
                    usersData.push(rowObj);
                });
                newUserModulePermissions.rows = usersData;
                setUserModulePermissions(newUserModulePermissions);
            }
            setLoading(false);
        });
    }
    const redirectToCreate = () => {
        let ids = inParticiapnt.attach(Downgraded).get().map((x) => x.userID);;
        let allParticipants = userDialog
            .attach(Downgraded)
            .get();
        let userList = allParticipants.filter(
            (x) => !ids.includes(x.userID)
        );
        userDialog.set(userList);
        openDialog.set(true);
    }
    const handleClose = () => {
        openDialog.set(false);
    };
    const getParticipants = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        if (eventInfo) {
            ApiHelper.get(
                APIURLConstants.GET_EVENT_PARTICIPANTS(
                    eventInfo.eventID,
                    1,
                    5000,
                    1

                )
            )
                .then((res) => {
                    if (res.data) {
                        let usersData = [];
                        if (res.data.rows.length > 0) {
                            res.data.rows.map((item) => {
                                usersData.push(item);
                            });
                        }
                        userDialog.set(usersData);
                    }
                })
                .catch((err) => {
                    loading.set(false);
                    if (err.response && err.response.status === 401) {
                        console.log(err);
                    }
                });
        }
    };
    const getAllParticipants = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
        ).then((res) => {
            if (res.data.rows) {
                allParticipants.set(res.data.rows);
            }
        });
    };

    return (
        <Box sx={{ width: '100%' }}>
            {loading ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box className="contentBox">
                    <UserMediaCircuitList
                        {...props}
                        data={userModulePermissions}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        getAllData={getAllData}
                        handleAdd={redirectToCreate}
                    />
                    {/* // ) : (
                    //     <ListItem className={classes.listItemContent}>
                    //         <Card
                    //             classes={{ root: classes.paperContent }}
                    //             sx={{ width: '100%' }}>
                    //             <CardContent
                    //                 sx={{ p: 2 }}
                    //                 className={classes.cardContent}>
                    //                 <Box className={classes.rowContent}>
                    //                     Please select the participant and
                    //                     modules for event
                    //                 </Box>
                    //             </CardContent>
                    //         </Card>
                    //     </ListItem>
                    // )} */}
                    {openDialog.get() && (
                        <UserListDialog
                            open={openDialog.get()}
                            title="Add Participant"
                            handleClose={handleClose}
                            users={userDialog.attach(Downgraded).get()}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            getParticipants={getParticipants}
                            getAllData={getAllData}
                            getAllParticipants={getAllParticipants}
                            eventParticipants={
                                allParticipants.get().length > 0
                                    ? allParticipants.attach(Downgraded).get()
                                    : []
                            }
                            mediaCircuitActivity={mediaCircuitActivity.attach(Downgraded).get()}
                            selectAllCheckBox={true}
                        />
                    )}
                </Box>
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};
export default AssignActivityList;

